import { render, staticRenderFns } from "./editThirdAccountSubmit.vue?vue&type=template&id=1a30ebdb&scoped=true&"
import script from "./editThirdAccountSubmit.vue?vue&type=script&lang=js&"
export * from "./editThirdAccountSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editThirdAccountSubmit.vue?vue&type=style&index=0&id=1a30ebdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30ebdb",
  null
  
)

export default component.exports